import { lazy } from 'react';
import { useLanguage } from '@/components/LanguageState';
import { effectiveEntryPath } from '@/components/entryLanguage';

// Fetch Danish copy in parallel with startup checks, never on an English entry.
let danishProvider;
const loadDanishProvider = () => danishProvider ||= import('@/components/LanguageContext').then(module => ({ default: module.LanguageProvider }));
if (!/^\/(?:en(?:\/|$)|about-en(?:\/|$))/i.test(effectiveEntryPath)) loadDanishProvider();
export const LanguageProvider = lazy(loadDanishProvider);
export { useLanguage };
export default useLanguage;